/**
 * SimulatorPage - Page Layer
 * Main page for credit simulation with form and results
 */

import { PageHeader } from '@/components/layout/PageHeader';
import { SimulatorForm, SimulatorResults } from '../../components';
import { useSimulator } from '../../hooks';

const BREADCRUMBS = [
  { label: 'Inicio', path: '/dashboard' },
  { label: 'Herramientas', path: '/tools/simulator' },
  { label: 'Simulador', path: '/tools/simulator' },
];

export function SimulatorPage() {
  const { result, isSimulating, simulate, reset } = useSimulator();

  return (
    <div>
      <PageHeader
        title="Simulador de Credito"
        subtitle="Simula creditos con parametros personalizados"
        breadcrumbs={BREADCRUMBS}
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div>
          <SimulatorForm onSubmit={simulate} isSubmitting={isSimulating} />
        </div>

        {result && (
          <div>
            <SimulatorResults result={result} onReset={reset} />
          </div>
        )}
      </div>
    </div>
  );
}
